export const EXTERNAL_LINKS = {
  FEEDBACK_FORM: "https://forms.gle/FrhVBgpRcd44h3Zr5",
  STRIPE_MANAGE_ACCOUNT: "https://billing.stripe.com/p/login/dR616laQm15LfsI6oo",
  API_DOCS: "https://api.videototextai.com/docs",
};
